export const CANCELLATION_CANCEL_TICKET_BEGIN = 'CANCELLATION_CANCEL_TICKET_BEGIN';
export const CANCELLATION_CANCEL_TICKET_SUCCESS = 'CANCELLATION_CANCEL_TICKET_SUCCESS';
export const CANCELLATION_CANCEL_TICKET_FAILURE = 'CANCELLATION_CANCEL_TICKET_FAILURE';
export const CANCELLATION_CANCEL_TICKET_DISMISS_ERROR = 'CANCELLATION_CANCEL_TICKET_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/cancellation/redux/constants.js